"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onRejected = exports.onFulfilled = void 0;
const ui_1 = require("modules/ui");
const request_1 = require("@hotmart/request");
const onFulfilled = (response) => response;
exports.onFulfilled = onFulfilled;
const onRejected = (error) => {
    const { response } = error || {};
    ui_1.UiService.handleInvalidToken(response);
    return Promise.reject(response || error);
};
exports.onRejected = onRejected;
request_1.axios.interceptors.response.use(exports.onFulfilled, exports.onRejected);
